import { useAtomValue } from "jotai";
import {
  ModalDialogBody,
  ModalDialogHeader,
  ModalDialogRoot,
  Text,
} from "@zapier/design-system";
import { canvasAtom } from "@zapier/canvas-state";

import EditDescriptionModalContent from "./EditDescriptionModalContent";

type Props = {
  onClosed: () => void;
};

export function EditDescriptionModal({ onClosed }: Props) {
  const canvas = useAtomValue(canvasAtom);
  const header = canvas?.description ? "Update description" : "Add description";

  return (
    <ModalDialogRoot isOpen={true} onOpenChange={onClosed} aria-label={header}>
      <ModalDialogHeader>
        <Text type="SectionHeader" margin="0 0 23px 0">
          {header}
        </Text>
      </ModalDialogHeader>
      <ModalDialogBody>
        <EditDescriptionModalContent onClosed={onClosed} />
      </ModalDialogBody>
    </ModalDialogRoot>
  );
}
